export default __webpack_public_path__ + "static/media/ColorChatWithFacility.d8e68ff2.svg";